import request from "@/utils/request";

// 获取告警列表
export function getAlarmPageList(data) {
  return request({
    url: "/alarm/page",
    method: "post",
    data: data
  });
}

// 获取告警详情
export function getAlarmDetail(alarmId) {
  return request({
    url: "/alarm/info?alarmId=" + alarmId,
    method: "get"
  });
}

// 添加告警列表
export function saveAlarm(data) {
  return request({
    url: "/alarm/save",
    method: "post",
    data: data
  });
}